// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { AuthProvider } from './auth/AuthContext'; // Temporär deaktivieren

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Wir lassen die App ohne Provider laufen */}
    <App />
  </React.StrictMode>
);

reportWebVitals();